import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 33 32.625",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32.625\" id=\"icon-play\"><path d=\"M27.767 19.667l-18.1 12.276a3.962 3.962 0 01-5.535-1.1 4.073 4.073 0 01-.675-2.247V4.041A4.012 4.012 0 017.446.006a3.96 3.96 0 012.221.683l18.1 12.276a4.063 4.063 0 011.092 5.6 4.013 4.013 0 01-1.092 1.1zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol